import { useFirestore } from "reactfire";

import { collection } from "firebase/firestore";

export const useMailCollection = () => {
  const mailCollectionRef = collection(useFirestore(), "mail");

  return { mailCollectionRef };
};
